import { combineReducers } from 'redux'
import ClientReducers from '@ClientStores/client-reducer'
import SharedReducers from '@SharedStores/shared.reducers'
import TempAuthReducer from '@Stores/auth/temp-auth.reducer'
import { AuthActionTypes } from '@Stores/auth/auth.action-types'
import * as Redux from 'redux'
import AuthReducer from './auth/auth.reducer'
import EducatorReducers from './educator/educator-reducer'
import InspectionReducers from './inspection/inspection-reducer'
import ReportReducers from './report/report-reducer'

const appReducer = combineReducers({
    client: ClientReducers,
    auth: AuthReducer,
    educator: EducatorReducers,
    shared: SharedReducers,
    inspection: InspectionReducers,
    tempAuth: TempAuthReducer,
    report: ReportReducers,
})

const rootReducer = (state: any, action: Redux.Action) => {
    switch (action?.type) {
        case AuthActionTypes.LOGOUT:
            return appReducer(undefined, action)

        default:
            return appReducer(state, action)
    }
}

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
